export const defaultHeader = {
  headers: {
    TravelERP: "true",
  },
};
